export const setupLogger = (toFile: boolean = false) => {
  return `

    $logFolder = "C:\\temp"
    $logFile = "$logFolder\\MantraBrowserDefenderSetup.log"

    function Write-Log {
        param([string]$Message)
        $timestamp = Get-Date -Format "yyyy-MM-dd HH:mm:ss"
        $logMessage = "$timestamp - $Message"

        if ($${toFile}) {
          if (!(Test-Path $logFolder)) {
            New-Item -ItemType Directory -Path $logFolder -Force | Out-Null
          }
          $logMessage | Out-File -FilePath $logFile -Append
        } else {
            Write-Host $logMessage
        }
    }
  `;
};

export const getActiveUserProfileFromEntra = `
  function Get-ActiveUserProfileEntra {
    try {
      $userProfiles = Get-CimInstance -ClassName Win32_UserProfile | 
        Where-Object { -not $_.Special -and $_.Loaded }

      if ($userProfiles) {
        # If multiple profiles are loaded, prefer the one with the most recent LastUseTime
        $activeProfile = $userProfiles | Sort-Object -Property LastUseTime -Descending | Select-Object -First 1

        $sid = $activeProfile.SID
        $username = (New-Object System.Security.Principal.SecurityIdentifier($sid)).Translate([System.Security.Principal.NTAccount]).Value

        return @{
          Username = $username
          SID = $sid
        }
      }
    }
    catch {
      Write-Log "Error getting active user profile: $_"
    }

    return $null
  }
`;

export const getActiveUserProfileFromLocal = `
  function Get-ActiveUserProfileLocal {
    $currentUserSID = [System.Security.Principal.WindowsIdentity]::GetCurrent().User.Value
    Write-Log "Current process user SID: $currentUserSID"

    $currentUserName = [System.Security.Principal.WindowsIdentity]::GetCurrent().Name
    Write-Log "Current process user name: $currentUserName"

    # Try to get the logged-in user using multiple methods
    $loggedInUser = $null
    $loggedInUserSID = $null

    # Method 1: Using Win32_Process
    $explorerProcesses = Get-WmiObject Win32_Process -Filter "Name='explorer.exe'"
    if ($explorerProcesses) {
      $loggedInUser = ($explorerProcesses | ForEach-Object { $_.GetOwner() } | Select-Object -Unique -Expand User)
      Write-Log "Logged-in user from explorer.exe: $loggedInUser"
    }

    # Method 2: Using Win32_ComputerSystem
    if (-not $loggedInUser) {
      $loggedInUser = Get-WmiObject -Class Win32_ComputerSystem | Select-Object -ExpandProperty UserName
      Write-Log "Logged-in user from Win32_ComputerSystem: $loggedInUser"
    }

    # Method 3: Using environment variable (last resort)
    if (-not $loggedInUser) {
      $loggedInUser = $env:USERNAME
      Write-Log "Logged-in user from environment variable: $loggedInUser"
    }

    if ($loggedInUser) {
      try {
        $objUser = New-Object System.Security.Principal.NTAccount($loggedInUser)
        $strSID = $objUser.Translate([System.Security.Principal.SecurityIdentifier])
        $loggedInUserSID = $strSID.Value
        Write-Log "Logged-in user SID: $loggedInUserSID"

        return @{
          Username = $loggedInUser
          SID = $loggedInUserSID
        }
      } catch {
        Write-Log "Error translating user to SID: $_"
      }
    } else {
      Write-Log "No logged-in user found."
      exit
    }
  }
`;

export const refreshHKCUHive = `
  function Refresh-HKUHive {
    param (
      [string]$SID
    )
    try {
      # Unload the hive
      [Microsoft.Win32.Registry]::Users.Close()
      [Microsoft.Win32.Registry]::Users.Flush()

      # Small delay to ensure the unload is complete
      Start-Sleep -Milliseconds 500

      # Reload the hive
      $null = [Microsoft.Win32.Registry]::Users.OpenSubKey($SID, $true)
      [Microsoft.Win32.Registry]::Users.Flush()

      Write-Log "HKU hive refreshed for SID: $SID"
    }
    catch {
      Write-Log "Error refreshing HKU hive: $_"
    }
  }
`;

export const getEmailFromUserIdentity = `
  function Get-EmailFromUserIdentity {
    $userIdentityLine = dsregcmd /status | Select-String "User Identity" -ErrorAction SilentlyContinue
    $email = ""
    if ($userIdentityLine -match ":\\s*(.+)") {
      $email = $matches[1].Trim()
    }

    return $email
  }
`;

export const getEmailFromRegistry = `
function Get-EmailFromRegistry {
    param(
        [string]$UserSID
    )
    
    try {
        # Create a new PSDrive for the user's hive if not already mounted
        if (-not (Test-Path "HKU:\\")) {
            New-PSDrive -Name HKU -PSProvider Registry -Root HKEY_USERS | Out-Null
        }
        
        # Check Outlook registry paths
        $outlookPaths = @(
            "HKU:\\$UserSID\\Software\\Microsoft\\Office\\16.0\\Outlook\\Profiles\\Outlook\\9375CFF0413111d3B88A00104B2A6676",
            "HKU:\\$UserSID\\Software\\Microsoft\\Office\\Outlook\\Settings"
        )
        
        foreach ($path in $outlookPaths) {
            if (Test-Path $path) {
                $emailProperty = Get-ItemProperty -Path $path -Name "Email" -ErrorAction SilentlyContinue
                if ($emailProperty -and $emailProperty.Email) {
                    return $emailProperty.Email
                }
            }
        }
        
        # Check Teams registry paths
        $teamsPath = "HKU:\\$UserSID\\Software\\Microsoft\\Teams"
        if (Test-Path $teamsPath) {
            $configFiles = Get-ChildItem -Path "$env:APPDATA\\Microsoft\\Teams\\*.json" -ErrorAction SilentlyContinue
            foreach ($file in $configFiles) {
                $content = Get-Content $file -Raw -ErrorAction SilentlyContinue
                if ($content -match '"email":"([^"]+)"') {
                    return $matches[1]
                }
            }
        }
    } catch {
        Write-Log "Error checking registry for email: $_"
    }
    return $null
  }
`;

export const getEmailFromADJoin = `
  function Get-AzureADJoinInfo {
    try {
        $joinInfo = Get-ItemProperty "HKLM:\\SYSTEM\\CurrentControlSet\\Control\\CloudDomainJoin\\JoinInfo\\*" -ErrorAction SilentlyContinue
        if ($joinInfo -and $joinInfo.UserEmail) {
            return $joinInfo.UserEmail
        }
    } catch {
        Write-Log "Error getting Azure AD join info: $_"
    }
    return $null
  }
`;

export const getEmailFromOneDrive = `
  function Get-EmailFromOneDrive {
    param(
        [string]$Username
    )
    
    try {
        $oneDrivePath = "C:\\Users\\$Username\\AppData\\Local\\Microsoft\\OneDrive\\settings\\Business1"
        if (Test-Path $oneDrivePath) {
            $configFiles = Get-ChildItem -Path $oneDrivePath -Filter "*.dat" -ErrorAction SilentlyContinue
            foreach ($file in $configFiles) {
                $content = Get-Content $file -Raw -ErrorAction SilentlyContinue
                if ($content -match "([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})") {
                    return $matches[1]
                }
            }
        }
    } catch {
        Write-Log "Error checking OneDrive configuration: $_"
    }
    return $null
  }
`;

export const getUserIdentityWhileRunningAsSystem = `
  function Get-UserIdentityWhileRunningAsSystem {
    $explorerProcesses = Get-WmiObject Win32_Process -Filter "Name='explorer.exe'"
    if (-not $explorerProcesses) {
        Write-Log "No explorer.exe processes found."
        return $null
    }

    $loggedInUser = ($explorerProcesses | ForEach-Object { $_.GetOwner() } | Select-Object -First 1)
    $username = $loggedInUser.User
    $domain = $loggedInUser.Domain
    $userSID = (New-Object System.Security.Principal.NTAccount("$domain\\$username")).Translate([System.Security.Principal.SecurityIdentifier]).Value

    Write-Log "Found logged-in user: $domain\\$username (SID: $userSID)"

    # Initialize email variable
    $email = Get-EmailFromUserIdentity

    if (-not [string]::IsNullOrEmpty($email)) {
      return $email
    }

    $email = Get-EmailFromRegistry -UserSID $userSID

    if (-not [string]::IsNullOrEmpty($email)) {
      return $email
    }

    $email = Get-EmailFromOneDrive -Username $username

    if (-not [string]::IsNullOrEmpty($email)) {
      return $email
    }

    $email = Get-AzureADJoinInfo

    Write-Log "Email: $email"

    return $email

  }
`;

export const processUserSpecificPath = `
  function Process-UserSpecificPath {
    param(
      [string]$userRegPath,
      [string]$currentUser,
      [string]$loggedInUserSID,
      [string]$enterpriseToken
    )

    Write-Log "Checking registry path: $userRegPath"

    $retryCount = 0
    $maxRetries = 5
    $retryDelay = 5 # seconds

    if (-not (Test-Path $userRegPath)) {
      Write-Log "Registry key not found. Attempting to create: $userRegPath"
      try {
        New-Item -Path $userRegPath -Force | Out-Null
        Refresh-HKUHive -SID $loggedInUserSID
        Write-Log "Registry key creation attempt successful."
      } catch {
        Write-Log "Error creating registry key: $_"
      }
    }

    while (-not (Test-Path $userRegPath) -and $retryCount -lt $maxRetries) {
        Write-Log "Waiting for registry key to be available. Attempt $($retryCount + 1) of $maxRetries"
        Start-Sleep -Seconds $retryDelay
        $retryCount++
    }

    if (Test-Path $userRegPath) {
      Write-Log "Registry key found: $userRegPath"
      New-ItemProperty -Path $userRegPath -Name "EnterpriseToken" -Value $enterpriseToken -Force
      Write-Log "Registry key vakue EnterpriseToken creation attempt successful."
      
      $acl = Get-Acl $userRegPath

      # Remove any existing Deny rules for the user
      $existingRules = $acl.Access | Where-Object { $_.IdentityReference.Value -eq $currentUser }
      foreach ($rule in $existingRules) {
        Write-Log "Existing rule - Identity: $($rule.IdentityReference), Type: $($rule.AccessControlType), Rights: $($rule.RegistryRights)"
    
        if ($rule.AccessControlType -eq 'Deny') {
          $acl.RemoveAccessRule($rule)
          Write-Log "Removed Deny rule for $currentUser"
        }
      }

      $allowRule = New-Object System.Security.AccessControl.RegistryAccessRule(
        $currentUser,
        "FullControl",
        "ContainerInherit,ObjectInherit",
        "None",
        "Allow"
      )

      $acl.AddAccessRule($allowRule)
      Set-Acl -Path $userRegPath -AclObject $acl

      Write-Log "Exception added for the logged-in user ($currentUser) on the registry key: $userRegPath"
    } else {
      Write-Log "Registry key not found for the logged-in user: $userRegPath"

      # Check if the parent keys exist
      $parentPath = Split-Path $userRegPath -Parent
      while (-not (Test-Path $parentPath) -and $parentPath -ne "HKU:\\$loggedInUserSID") {
        $parentPath = Split-Path $parentPath -Parent
      }
      Write-Log "Closest existing parent path: $parentPath"
      
      # List contents of the closest existing parent path
      Get-ChildItem $parentPath -Recurse | ForEach-Object {
        Write-Log "Found item: $($_.Name)"
      }
    }
  }
`;

export const processUserSpecificPathAdminOnlyDeployment = (
  withExitOnEmailNotFound: boolean = false,
) => {
  const exitScriptForEmail = withExitOnEmailNotFound
    ? `
    if (-not $email) {
      Write-Log "Unable to detect email using any method. Exiting."
      exit 0
    }
  `
    : "";

  return `
    ${getUserIdentityWhileRunningAsSystem}

    function Process-UserSpecificPath {
      param(
        [string]$userRegPath,
        [string]$currentUser,
        [string]$loggedInUserSID,
        [string]$enterpriseToken
      )

      Write-Log "Checking registry path: $userRegPath"

      $retryCount = 0
      $maxRetries = 5
      $retryDelay = 5 # seconds

      if (-not (Test-Path $userRegPath)) {
        Write-Log "Registry key not found. Attempting to create: $userRegPath"
        try {
          New-Item -Path $userRegPath -Force | Out-Null
          Refresh-HKUHive -SID $loggedInUserSID
          Write-Log "Registry key creation attempt successful."
        } catch {
          Write-Log "Error creating registry key: $_"
        }
      }

      while (-not (Test-Path $userRegPath) -and $retryCount -lt $maxRetries) {
          Write-Log "Waiting for registry key to be available. Attempt $($retryCount + 1) of $maxRetries"
          Start-Sleep -Seconds $retryDelay
          $retryCount++
      }

      if (Test-Path $userRegPath) {
        Write-Log "Registry key found: $userRegPath"
        New-ItemProperty -Path $userRegPath -Name "EnterpriseToken" -Value $enterpriseToken -Force
        Write-Log "Registry key vakue EnterpriseToken creation attempt successful."

        $email = Get-UserIdentityWhileRunningAsSystem

        ${exitScriptForEmail}

        New-ItemProperty -Path $userRegPath -Name "EnterpriseUserId" -Value $email -Force
        Write-Log "Registry key vakue EnterpriseUserId creation attempt successful."
      } else {
        Write-Log "Registry key not found for the logged-in user: $userRegPath"

        # Check if the parent keys exist
        $parentPath = Split-Path $userRegPath -Parent
        while (-not (Test-Path $parentPath) -and $parentPath -ne "HKU:\\$loggedInUserSID") {
          $parentPath = Split-Path $parentPath -Parent
        }
        Write-Log "Closest existing parent path: $parentPath"
        
        # List contents of the closest existing parent path
        Get-ChildItem $parentPath -Recurse | ForEach-Object {
          Write-Log "Found item: $($_.Name)"
        }
      }
    }
  `;
};

export const handlePathForActiveUser = (
  enterpriseToken: string,
  browserSpecificPath: string,
) => {
  return `
    if ($activeUser) {
      $loggedInUser = $activeUser.Username
      $loggedInUserSID = $activeUser.SID
      Write-Log "Active user detected Entra/AD - Username: $loggedInUser, SID: $loggedInUserSID"
    } else {
      # Fallback to local accounts
      $activeUser = Get-ActiveUserProfileLocal
      if ($activeUser) {
        $loggedInUser = $activeUser.Username
        $loggedInUserSID = $activeUser.SID
        Write-Log "Active user detected local - Username: $loggedInUser, SID: $loggedInUserSID"
      }
    } 

    $currentUser = $loggedInUser

    # Create a new PSDrive for the user's hive
    New-PSDrive -Name HKU -PSProvider Registry -Root HKEY_USERS | Out-Null
    
    # Construct the full path to the user's registry key
    $regPath = "HKU:\\$loggedInUserSID\\Software\\Policies\\${browserSpecificPath}"

    Write-Log "Processing path: $regPath"
    Process-UserSpecificPath -userRegPath $regPath -currentUser $currentUser -loggedInUserSID $loggedInUserSID -enterpriseToken ${enterpriseToken}
  `;
};

export const runSetup = (
  enterpriseToken: string,
  browserSpecificPath: string,
  cleanup: string = "",
) => {
  return `
    # Check for admin rights
    if (-NOT ([Security.Principal.WindowsPrincipal][Security.Principal.WindowsIdentity]::GetCurrent()).IsInRole([Security.Principal.WindowsBuiltInRole] "Administrator")) {
      Write-Warning "You might not have Administrator rights to run this script!"
    }

    $activeUser = Get-ActiveUserProfileEntra

    try {
      ${handlePathForActiveUser(enterpriseToken, browserSpecificPath)}
      ${cleanup}
    }
    catch {
      Write-Log "An error occurred: $_"
    }
    finally {
      # Clean up: Remove the HKU PSDrive
      Remove-PSDrive -Name HKU -ErrorAction SilentlyContinue
      Write-Log "Script execution completed."
    }
  `;
};

export const runSetupWithScheduledTask = (
  enterpriseToken: string,
  browserSpecificPath: string,
  browser: string,
) => {
  const scheduledTaskRemove = `
    $taskName = "MantraBrowserDefenderSetupFor${browser}"
    Unregister-ScheduledTask -TaskName $taskName -Confirm:$false
    Write-Log "Task self-cleanup: Removed scheduled task '$taskName' to prevent future runs."
  `;

  return runSetup(enterpriseToken, browserSpecificPath, scheduledTaskRemove);
};

export const waitForUserToLogon = `
  $maxWaitSeconds = 300  # 5 minutes
  $elapsed = 0

  while ($elapsed -lt $maxWaitSeconds) {
    $session = query user | Where-Object { $_ -match "Active" }
    if ($session) { break }
    Start-Sleep -Seconds 5
    $elapsed += 5
  }

  if (-not $session) {
    Write-Log "No user login detected within $maxWaitSeconds seconds."
    exit 1
  }
`;
